import { autonomyActionTypes } from '@/pages/autonomy/Constants';

const initialState = {
	steps: [],
	loading: false,
	isDragging: false,
	openAutonomyModal: false,
};

const autonomyReducer: any = (state: any = initialState, action: any) => {
	const { type, payload } = action;

	const { isDragging, openAutonomyModal, steps } = payload || {};

	switch (type) {
		case autonomyActionTypes.GET_AUTONOMY_STEPS_REQUEST:
			return {
				...state,
				loading: true,
			};

		case autonomyActionTypes.GET_AUTONOMY_STEPS_SUCCESS:
			return {
				...state,
				steps,
				loading: false,
			};

		case autonomyActionTypes.GET_AUTONOMY_STEPS_ERROR:
			return {
				...state,
				loading: false,
			};

		case autonomyActionTypes.SET_DRAGGING_STATE:
			return {
				...state,
				isDragging,
			};

		case autonomyActionTypes.TOGGLE_AUTONOMY_MODAL:
			return {
				...state,
				openAutonomyModal,
			};

		default:
			return state;
	}
};

export default autonomyReducer;
